import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllSellers = (page, size) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.sellerProfiles,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      page,
      size,
    },
  });
};

export const fetchSellerDetails = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.sellerProfile(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteSellerProfile = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.sellerProfile(id),
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addSellerProfile = (data, id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url:
      id !== null
        ? config.routes.sellerProfile(id)
        : config.routes.sellerProfileCreate,
    method: id !== null ? "put" : "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      address: data?.address,
      city: data?.city,
      contactemail: data?.contactEmail,
      contactname: data?.contactName,
      country: data?.country,
      domain: data?.domain,
      email: data?.email,
      fax: data?.fax,
      name: data?.name,
      occupation: data?.occupation,
      phone: data?.phone,
      phone2: data?.phone2,
      postalcode: data?.postalCode,
      region: data?.region,
      website: data?.website,
      ownership_type: data?.ownership_type,
      has_loan: data?.has_loan,
      finantial_institution: data?.loan_details?.institution,
      loan_amount: parseFloat(data?.loan_details?.balance),
      equity:
        data?.equity === "" || data?.equity == null
          ? null
          : Math.max(0, Math.min(100, parseFloat(data?.equity))),
      creditor: data?.creditor,
      partners: Array.isArray(data?.partners)
        ? data.partners.filter(
            (p) =>
              (p?.partner_name && p.partner_name.trim() !== "") ||
              (p?.partner_email && p.partner_email.trim() !== "") ||
              (p?.partnership_percentage !== "" &&
                p?.partnership_percentage != null)
          )
        : [],
      short_term_debt_amount:
        data?.short_term_debt_amount === "" ||
        data?.short_term_debt_amount == null
          ? null
          : parseFloat(data?.short_term_debt_amount),
      long_term_debt_amount:
        data?.long_term_debt_amount === "" ||
        data?.long_term_debt_amount == null
          ? null
          : parseFloat(data?.long_term_debt_amount),
      funding_rounds: {
        seed:
          data?.funding_rounds?.seed === "" || data?.funding_rounds?.seed == null
            ? null
            : parseFloat(data?.funding_rounds?.seed),
        a:
          data?.funding_rounds?.a === "" || data?.funding_rounds?.a == null
            ? null
            : parseFloat(data?.funding_rounds?.a),
        b:
          data?.funding_rounds?.b === "" || data?.funding_rounds?.b == null
            ? null
            : parseFloat(data?.funding_rounds?.b),
        c:
          data?.funding_rounds?.c === "" || data?.funding_rounds?.c == null
            ? null
            : parseFloat(data?.funding_rounds?.c),
      },
      professional_required: data?.professional_required,
      need_professionals: data?.need_professionals == "true" ? true : false,
    },
  });
};
